/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Already_Issued_ManualInputs */

const vi_einvoice_already_issued_manual = /** @type {(inputs: Einvoice_Already_Issued_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nháp đã được ký trên MISA. Bỏ tick 'Xoá nháp cũ' và nhập số đó.`)
};

/**

* @param {Einvoice_Already_Issued_ManualInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_already_issued_manual = /** @type {((inputs?: Einvoice_Already_Issued_ManualInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Already_Issued_ManualInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_already_issued_manual(inputs)
});